<template>
  <div />
</template>

<script>
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'NotificationCom',
  computed: {
    ...mapGetters('error-store', ['messagePool']),
  },
  watch: {
    messagePool: 'showNotification',
  },
  methods: {
    showNotification({ variant, msg, title }) {
      // Dynamic icons for different notification types
      const icons = {
        danger: 'AlertTriangleIcon', // errors - red triangle
        success: 'CheckCircleIcon', // success - green checkmark
        warning: 'AlertCircleIcon', // warnings - yellow circle
        info: 'InfoIcon', // information - blue circle
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text: msg,
          icon: icons[variant] || 'AlertTriangleIcon', // use corresponding icon
          variant,
        },
      })
    },
  },
}
</script>
